export function isFrontendRbacDisabled() {
  return String(import.meta.env.VITE_DISABLE_RBAC || "").toLowerCase() === "true";
}

